<div class="row">
  <div class="col-md-6" *ngFor="let benefit of benefits">
    <fgb-benefit-item [benefit]="benefit" [disabled]="disabled"></fgb-benefit-item>
  </div>
</div>
